export enum SearchResultType {
  DialPad = 'dialpad',
  Call = 'call',
}
